export const initialState = {
    name: {
        value: '',
        min: 3,
        max: 14,
        hasError: false,
        errorMessage: ''
    },
    lastname: {
        value: '',
        min: 3,
        max: 14,
        hasError: false,
        errorMessage: ''
    },
    phonenumber: {
        value: '',
        min: 10,
        max: 12,
        hasError: false,
        errorMessage: ''
    },
    role: {
        value: 'user',
        max: 20,
        hasError: false,
        errorMessage: ''
    }
};

export const reducer = (state, action) => {
    switch (action.type) {
        case 'FETCH':
            return {
                ...state,
                name: {
                    ...state.name,
                    value: action.name
                },
                lastname: {
                    ...state.lastname,
                    value: action.lastname
                },
                phonenumber: {
                    ...state.phonenumber,
                    value: action.phonenumber
                },
                role: {
                    ...state.role,
                    value: action.role
                }
            };
        case 'UPDATE':
            return {
                ...state,
                [action.param]: {
                    ...state[action.param],
                    value: action.value,
                    hasError: false,
                    errorMessage: ''
                }
            };
        case 'ADD_ERROR':
            return {
                ...state,
                [action.param]: {
                    ...state[action.param],
                    hasError: true,
                    errorMessage: action.message
                }
            };
        case 'CLEAR':
            return initialState;
        default:
            return state;
    }
};